import { render } from "./SwipeItem.vue?vue&type=template&id=07ff2a69&scoped=true"
import script from "./SwipeItem.vue?vue&type=script&lang=js"
export * from "./SwipeItem.vue?vue&type=script&lang=js"

import "./SwipeItem.vue?vue&type=style&index=0&id=07ff2a69&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ff2a69"]])

export default __exports__